var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDocumentPreview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4398 4.21616L12.0416 0.049475C11.9401 -0.0467273 11.8036 -0.1 11.6618 -0.1H2.42574C1.40542 -0.1 0.566504 0.687208 0.566504 1.66668V18.3334C0.566504 19.3128 1.40543 20.1 2.42578 20.1H14.7406C15.7609 20.1 16.5998 19.3128 16.5998 18.3333V4.58332C16.5998 4.44428 16.5415 4.31252 16.4398 4.21616ZM12.2017 3.33336V1.65503L14.7473 4.06668H12.9813C12.5465 4.06668 12.2017 3.73248 12.2017 3.33336ZM15.5202 18.3333C15.5202 18.7324 15.1754 19.0666 14.7406 19.0666H2.42578C1.99095 19.0666 1.64616 18.7324 1.64616 18.3333V1.66668C1.64616 1.26756 1.99095 0.933359 2.42578 0.933359H11.1221V3.33336C11.1221 4.31279 11.961 5.1 12.9813 5.1H15.5202V18.3333Z",
    fill: "#757575",
    stroke: "#757575",
    strokeWidth: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9539_5350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.08137 14.1002C9.93257 14.1002 11.4333 12.5996 11.4333 10.7484C11.4333 8.89717 9.93257 7.39648 8.08137 7.39648C6.23018 7.39648 4.72949 8.89717 4.72949 10.7484C4.72949 12.5996 6.23018 14.1002 8.08137 14.1002Z",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5952 13.2627L12.5505 15.218",
    stroke: "#757575",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9539_5350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.93835,
    height: 8.93835,
    fill: "white",
    transform: "translate(4.1709 6.83789)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocumentPreview);
export default __webpack_public_path__ + "static/media/ic-document-preview.36630db2f9664d571780e91d6134b4c6.svg";
export { ForwardRef as ReactComponent };